import React, { useState } from "react";
// import "./navbar.css";
import '../styles/navbar.css'
import brnd from "../assets/images/brnd.png"
import brnd1 from "../assets/images/brnd-dark.png"
import brnd2 from "../assets/images/DayTona.png"
import {
    FaFacebookSquare,
    FaInstagramSquare,
    FaYoutubeSquare,
} from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";

import { a } from "react-router-dom";

const Navbar = () => {
    const [showMediaIcons, setShowMediaIcons] = useState(false);
    return (
        <>
            <nav className="main-nav container-fluid d-flex justify-between">
                {/* 1st logo part  */}
                <div className="logo nav-brand col-md">
                    <img src={brnd2} alt="asd" className="brnd" />
                </div>

                {/* 2nd menu part  */}
                <div
                    className={` col-md ${showMediaIcons ? "menu-link col-md-6 mobile-menu-link" : "menu-link"} `}>
                    <ul>
                        <li className="nav-item">
                            <a href="/">Race</a>
                        </li>
                        <li className="nav-item">
                            <a href="/">NFT Horses</a>
                        </li>
                        <li className="nav-item">
                            <a href="/">$DayTona</a>
                        </li>
                        <li className="nav-item">
                            <a href="/">Roadmap</a>
                        </li>
                        <li className="nav-item">
                            <a href="/">About</a>
                        </li>
                        <li className="nav-item" id="tog">
                            <div className="d-flex align-items-center ml-5 css-wwiaj0">
                                <div className="react-toggle react-toggle--checked">
                                    <div className="react-toggle-track">
                                        <div className="react-toggle-track-check">
                                            <svg
                                                stroke="currentColor"
                                                fill="none" stroke-width="2"
                                                viewBox="0 0 24 24"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                height="0.6em" width="0.6em"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z">
                                                </path>
                                            </svg>
                                        </div>
                                        <div className="react-toggle-track-x">
                                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="12" cy="12" r="5"></circle>
                                                <line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
                                        </div>
                                    </div>
                                    <div className="react-toggle-thumb"></div>
                                    <input className="react-toggle-screenreader-only" type="checkbox" checked="checked" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                {/* 3rd social media links */}
                <div className="social-media col-md">
                    {/* <ul> */}
                    <button className="connect">Connect Wallet</button>
                    {/* </ul> */}

                    {/* hamburget menu start  */}
                    <div className="hamburger-menu">
                        <a href="#" onClick={() => setShowMediaIcons(!showMediaIcons)}>
                            <GiHamburgerMenu />
                        </a>
                    </div>
                </div>
            </nav>

            {/* hero section  */}
            {/* <section className="hero-section">
        <p>Welcome href </p>
        <h1>Thapa Technical</h1>
      </section> */}
        </>
    );
};

export default Navbar;































{/* <div className="as">
                    <div className="navbar-start css-rwgnzp">
                        <a className="nav-item" href="https://derace.com/races">Race</a>
                        <a className="nav-item" href="https://derace.com/horses">NFT Horses</a>
                        <a className="nav-item" href="https://derace.com/derc">$DERC</a>
                        <a className="nav-item" href="https://derace.com/roadmap">Roadmap</a>
                        <a className="nav-item" href="https://derace.com/about">About</a>
                        <div className="is-flex is-align-items-center ml-5 css-wwiaj0">
                            <div className="react-toggle react-toggle--checked">
                                <div className="react-toggle-track">
                                    <div className="react-toggle-track-check"><svg
                                        stroke="currentColor"
                                        fill="none" stroke-width="2"
                                        viewBox="0 0 24 24"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        height="1em" width="1em"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z">
                                        </path>
                                    </svg>
                                    </div>
                                    <div className="react-toggle-track-x">
                                        <svg
                                            stroke="currentColor"
                                            fill="none" stroke-width="2"
                                            viewBox="0 0 24 24"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            height="1em" width="1em"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="12" r="5">
                                            </circle>
                                            <line x1="12" y1="1" x2="12"
                                                y2="3"></line>
                                            <line x1="12" y1="21" x2="12"
                                                y2="23"></line>
                                            <line x1="4.22" y1="4.22"
                                                x2="5.64" y2="5.64">
                                            </line>
                                            <line x1="18.36" y1="18.36"
                                                x2="19.78" y2="19.78">
                                            </line>
                                            <line x1="1" y1="12" x2="3"
                                                y2="12"></line>
                                            <line x1="21" y1="12" x2="23"
                                                y2="12"></line>
                                            <line x1="4.22" y1="19.78"
                                                x2="5.64" y2="18.36">
                                            </line>
                                            <line x1="18.36" y1="5.64"
                                                x2="19.78" y2="4.22">
                                            </line>
                                        </svg>
                                    </div>
                                </div>
                                <div className="react-toggle-thumb"></div>
                                <input className="react-toggle-screenreader-only" type="checkbox" checked="checked" />
                            </div>
                        </div>
                    </div>
                </div> */}